<div class="content">
  <div class="content__menu-bar">Markets</div>
  <div
    class="content__resize-container resize-able scrollable-content"
    appResizerVertical
    appResizerHorizontal
    [minWidth]="60"
    [minHeight]="0"
  >
    <div class="content__main">
      <app-historical-graph
        *ngFor="let hist of historicalGraphArray; let i = index"
        [currencyPairs]="currencies"
        [widgetId]="i"
      ></app-historical-graph>
      <div>
        <app-forward-curve
          *ngFor="let fwdCurve of forwardCurveArray; let i = index"
          [currencyPairs]="currencies"
          [widgetId]="i"
        ></app-forward-curve>
        <app-volatility-surface
          *ngFor="let vol of volatilitySurfaceArray; let i = index"
          [currencyPairs]="currencies"
          [widgetId]="i"
        ></app-volatility-surface>
      </div>
    </div>
  </div>
</div>
